<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="2"
                lg="3"
                md="2"
                sm="2"
            >
                <h3>Job Aging</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                cols="12"
                lg="6"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="filter.mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-divider style="margin-bottom: 15px;"></v-divider>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                cols="12"
                lg="6"
                md="4"
                sm="12"
            >
                <label>Sales Person</label>
                <v-combobox
                    v-model="filter.sellerSelected"
                    :items="listSellers" 
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="6"
                md="4"
                sm="12"
            >
                <label>Supervisor</label>
                <v-combobox
                    v-model="filter.supervisorSelected"
                    :items="listSupervisors" 
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="12"
            >
                <label>City</label>
                <v-combobox
                    v-model="filter.citySelected"
                    :items="listCity" 
                    item-text="codeStateDescriptionCity"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="4"
                sm="8"
            >
                <label>Subdivision</label>
                <v-text-field
                    v-model="filter.subdivision"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                cols="12"
                lg="3"
                md="3"
                sm="12"
            >
                <label>Origin</label>
                <v-combobox
                    v-model="filter.customerOriginSelected"
                    :items="listCustomerOrigin"
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="2"
                sm="8"
            >
                <label>Zipcode</label>
                <v-text-field
                    v-model="filter.zipcode"
                    single-line
                    outlined
                    dense
                >
                </v-text-field>
            </v-col>
            <v-col 
                style="text-align: right; margin-top: 22px;"
                cols="12"
                lg="1"
                md="1"
                sm="8"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                style="text-align: right;"
                cols="12"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="exportFile(URL_REPORT_JOBS_AGING, getFilterRequest());"
                        >
                            Export PDF
                        </v-btn>
                    </template>
                    <span>Export Report to PDF</span>
                </v-tooltip>
            </v-col>

            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="listJobsAging"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item="{ item }">
                        <tr
                            :style="{
                                backgroundColor: item.situation == 2 ? 'var(--color__card_waiting_solve_problem)' : 'white' // muda conforme condição
                            }"
                        >
                            <td>
                                <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <a @click="goToServiceDetails(item.jobId)" v-on="on" target="_blank">
                                    {{ item.jobId }}
                                    </a>
                                </template>
                                <span>Job Details</span>
                                </v-tooltip>
                            </td>
                            <td>
                                {{ item.contractDateFormatted }}
                            </td>
                            <td>
                                {{ item.projectName }}
                            </td>
                            <td>
                                {{ item.salesPersonName }}
                            </td>
                            <td>
                                {{ item.supervisorName }}
                            </td>
                            <td>
                                {{ item.statusDescription }}
                            </td>
                            <td>
                                {{ item.customerName }}
                            </td>
                            <td>
                                {{ item.customerAddress }}
                            </td>
                            <td>
                                {{ item.customerCity }}
                            </td>
                            <td>
                                <span :style="{ color: item.age < 0 ? 'red' : 'green' }">
                                <strong>{{ item.dwellTimeDescription }}</strong>
                                </span>
                            </td>
                            <td>
                                <span :style="{ color: item.situation == 2 ? 'red' : '' }">
                                <strong>{{ item.onHoldDescription }}</strong>
                                </span>
                            </td>
                            <td>
                                <strong>{{ item.valueFormatted }}</strong>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import * as moment from 'moment';
    import { 
        URL_REPORT_JOBS_AGING
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        data: () => ({
            
            loading: false,
            
            tabGraph: null,

            listSellers: [],
            listSupervisors: [],
            listCity: [],
            listCustomerOrigin: [],

            filter: {
                sellerSelected: null,
                supervisorSelected: null,
                citySelected: null,
                subdivision: null,
                zipcode: null,
                customerOriginSelected: null,
                startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY')
            },

            headers: [
                { text: "Job Id", value: "jobId", sortable: true },
                { text: "Contract Date", value: "contractDateFormatted", sortable: true },
                { text: "Project Name", value: "projectName", sortable: true },
                { text: "Sales Person", value: "salesPersonName", sortable: true },
                { text: "Supervisor", value: "supervisorName", sortable: true },
                { text: "Stage", value: "statusDescription", sortable: true },
                { text: "Customer", value: "customerName", sortable: true },
                { text: "Address", value: "customerAddress", sortable: true },
                { text: "City", value: "customerCity", sortable: true },
                { text: "Dwell Time", value: "dwellTimeDescription", sortable: true },
                { text: "On Hold", value: "onHoldDescription", sortable: true },
                { text: "Amount", value: "valueFormatted", width:"15%", sortable: true }
            ],

            options: { rowsPerPage: 10, page: 1 },
            listJobsAging: [],
            
            mnuStartDate: false,
            mnuEndDate: false,

            moneyFormat: {
                prefix: '$ ',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 2,
            },

            URL_REPORT_JOBS_AGING
        }),

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            async getLists() {
                this.listSellers = await this.$store.dispatch("userModule/ListSalesPerson");
                this.listCity = await this.$store.dispatch("cityModule/List", 0);
                this.listCustomerOrigin = await this.$store.dispatch("customerOriginModule/List");
                const listUserResponse = await this.$store.dispatch("userModule/List");
                this.listSupervisors = listUserResponse.filter(usr => usr.constructionSupervisor == 1);
            },

            async getRegisters() {
                this.showLoading();
                await this.getJobsAging();
                this.hideLoading();
            },

            getFilterRequest() {

                let idSalesPerson = 0;
                let idSupervisor = 0;
                let idCity = 0;
                let idCustomerOrigin = 0;

                if (this.filter.sellerSelected != null && this.filter.sellerSelected != undefined) {
                    idSalesPerson = this.filter.sellerSelected.id;
                }

                if (this.filter.supervisorSelected != null && this.filter.supervisorSelected != undefined) {
                    idSupervisor = this.filter.supervisorSelected.id;
                }

                if (this.filter.citySelected != null && this.filter.citySelected != undefined) {
                    idCity = this.filter.citySelected.id;
                }

                if (this.filter.customerOriginSelected != null && this.filter.customerOriginSelected != undefined) {
                    idCustomerOrigin = this.filter.customerOriginSelected.id;
                }

                const startDate = this.filter.startDate;
                const endDate = this.filter.endDate;
                const subdivision = this.filter.subdivision;
                const zipcode = this.filter.zipcode;
                
                const request = {
                    idSalesPerson,
                    idSupervisor,
                    idCity,
                    subdivision,
                    startDate,
                    endDate,
                    idCustomerOrigin,
                    zipcode
                }

                return request;
            },

            async getJobsAging() {

                this.listJobsAging = await this.$store.dispatch("reportModule/JobsAging", this.getFilterRequest());
            },

            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: {id: id} });
            },
        },

        async created() {
            this.showLoading();
            await this.getLists();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>

<style>

    table > tbody > tr {
        cursor: pointer !important;
    }

</style>